/**
 * Utility functions for the SiteUrlDropdown component
 */

/**
 * Gets the demo domain URL based on the site domain
 * @param siteDomain - The domain of the site
 * @returns The demo domain URL as a string
 */
export const getDemoDomain = (siteDomain: string): string => {
  let demoUrl = '';
  if (siteDomain?.includes('-stage')) {
    demoUrl =
      'https://' +
      siteDomain?.slice(0, siteDomain?.length - 17) +
      'linkplatform-stage.com';
  } else {
    demoUrl =
      'https://' + siteDomain?.slice(0, siteDomain?.length - 4) + '-demo.com';
  }
  if (siteDomain === 'developer-stage.optumoi.com') {
    demoUrl = 'https://developer-stage.linkplatform-stage.com';
  }
  return demoUrl;
};

/**
 * Gets the live domain URL based on the site domain
 * @param siteDomain - The domain of the site
 * @returns The live domain URL as a string
 */
export const getLiveDomain = (siteDomain: string): string => {
  return 'https://' + siteDomain;
};

/**
 * Truncates a URL if it's longer than the specified length
 * @param urlIndex - The index of the URL (0 for live, 1 for demo)
 * @param siteDomain - The domain of the site
 * @returns Truncated URL string with prefix
 */
export const truncateUrl = (urlIndex: number, siteDomain: string): string => {
  const url =
    urlIndex === 0
      ? 'Live URL: ' + getLiveDomain(siteDomain)
      : 'Demo URL: ' + getDemoDomain(siteDomain);
  return url.length > 55 ? url.substring(0, 55) + '...' : url;
};
